/* global Linear */
import merge from 'lodash/merge';
import clone from 'lodash/clone';
import fluxDefaults from './defaultsLarge';

const height = 100;
const gapHeight = 40;

module.exports = merge(clone(fluxDefaults, true), {
    // particleScale: 0.6,
    // particlesRadius: 0.07,
    // particlesDampingStrength: 0.5,
    gravity: 1,
    initialTicks: 100,
    walls: [
        // left
        {
            width: 20,
            height: '100%',
            x: '-50%',
            y: '0%',
        },
        // top
        {
            width: '120%',
            height: 20,
            x: '-50%',
            y: `${height - gapHeight}%`,
        },
        // bottom
        {
            x: '-50%',
            y: `${height - 2}%`,
            width: '140%',
            height: 20,
        },
        // bottom right 1
        {
            width: '40%',
            height: 20,
            x: '55%',
            y: `${height - 3}%`,
            angle: -10,
        },
        // bottom right 2
        {
            width: '40%',
            height: 20,
            x: '65%',
            y: `${height - 4}%`,
            angle: -20,
        },
        // bottom right 3
        {
            width: '40%',
            height: 20,
            x: '70%',
            y: `${height - 8}%`,
            angle: -40,
        },
        // bottom right 4
        {
            width: '40%',
            height: 20,
            x: '80%',
            y: `${height - 12}%`,
            angle: -65,
        },
        // bottom right 5
        {
            width: '40%',
            height: 20,
            x: '83%',
            y: `${height - 16}%`,
            angle: -80,
        },
        // top right 1
        {
            width: '40%',
            height: 20,
            x: '55%',
            y: `${height - gapHeight + 0}%`,
            angle: 10,
        },
        // top right 2
        {
            width: '40%',
            height: 20,
            x: '65%',
            y: `${height - gapHeight + 4}%`,
            angle: 20,
        },
        // top right 3
        {
            width: '40%',
            height: 20,
            x: '70%',
            y: `${height - gapHeight + 8}%`,
            angle: 40,
        },
        // top right 4
        {
            width: '40%',
            height: 20,
            x: '80%',
            y: `${height - gapHeight + 16}%`,
            angle: 65,
        },
        // top right 5
        {
            width: '40%',
            height: 20,
            x: '83%',
            y: `${height - gapHeight + 20}%`,
            angle: 80,
        },
        // right 4
        // {
        //     width: 20,
        //     height: '20%',
        //     x: '91%',
        //     y: `${height - gapHeight - 10}%`,
        // },
    ],
    movingWalls: [
        // bottom left
        {
            width: 20,
            height: '20%',
            x: '-80%',
            y: '85%',
            angle: 20,
            tween: {
                x: '0%',
                duration: 1,
                repeat: -1,
                ease: Linear.easeNone,
            },
        },
    ],
    blobs: [
        {
            x: '-30%',
            y: '62%',
            width: '40%',
            height: '40%',
            color: [0, 0, 0, 255],
        },
        {
            x: '10%',
            y: '62%',
            width: '5%',
            height: '40%',
            color: [255, 0, 0, 255],
        },
        {
            x: '20%',
            y: '62%',
            width: '10%',
            height: '40%',
            color: [0, 255, 0, 255],
        },
        {
            x: '30%',
            y: '62%',
            width: '20%',
            height: '40%',
            color: [0, 0, 255, 255],
        },
    ],
});



// WEBPACK FOOTER //
// ./js/flux/smallBucketAnalyser.js